function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import Url from 'url-parse';
import { getPageUtms } from './utils';
import { createCart as createBTCheckoutCart, redirectToCheckout as redirectToBTCheckout } from './btCheckout';
import { hideLoadingOverlay, showLoadingOverlay } from './loadingOverlay';
import { CheckoutProvider } from './enum';
import { trackAddToCartEvent } from './trackers/utils';
import { BTCheckoutCartAdapter } from './trackers/adapater/cart/btCheckoutCartAdapter';
import { sendToShopifyCheckout } from './lockedInLanderCheckoutLinks';
import { getOfferCYPs } from './lockedInLanderOffers';
var _window$bt$lil = window.bt.lil;
_window$bt$lil = _window$bt$lil === void 0 ? {} : _window$bt$lil;
var _window$bt$lil$optIn = _window$bt$lil.optIn,
    optIn = _window$bt$lil$optIn === void 0 ? {} : _window$bt$lil$optIn;

(function () {
  var pageUrl = new Url(window.location.href, true);

  function _getTrackersLayer() {
    return window[window.bt.settings.trackersDataLayer];
  }

  function _isCPA() {
    var isCPASetting = window.bt && window.bt.settings && window.bt.settings.isCPA;
    return typeof isCPASetting === 'undefined' ?
    /* default setting */
    true : isCPASetting;
  }

  function validateEmail(email, callback) {
    var emailRegex = /^(?!.{255,})(([a-z]{2}@)|((?!.*[+.-]+@)(?!.*[+-._]{2,})(?![^a-z]+@)[a-z0-9][+a-z0-9._-]+))@(([a-z0-9]([a-z0-9-_]+\.)+|[a-z]\.)[a-z]{2,})$/i;
    var url = 'https://www.xverify.com/services/emails/verify/?type=json&apikey=1007729-ADDD229C&domain=biotrust.com&email=' + encodeURIComponent(email); // First test regex

    if (!emailRegex.test(email) || /\b(enter|youremail)\b/i.test(email)) {
      if (callback) {
        callback(false);
      }

      return false;
    } // If we don't have a call back just return true as we are only validating basic email


    if (!callback) {
      return true;
    }

    return $.ajax({
      url: url,
      timeout: 2000,
      dataType: 'jsonp'
    }).done(function (data) {
      try {
        if (data.email.responsecode === 1 || data.email.responsecode === 3) {
          callback(true);
        } else {
          callback(false);
        }
      } catch (err) {
        callback(true);
      }
    }).fail(function () {
      callback(true);
    });
  }

  function isRegisteredLead(email, dealName) {
    // eslint-disable-next-line no-unused-vars
    return new Promise(function (resolve, reject) {
      var ck = Cookies.getJSON('choffer');

      if (ck && ck[dealName] === email) {
        resolve(true);
        return;
      }

      $.get(window.bt.settings.leadsApi + 'deal/conversion', {
        Email: email,
        DealName: dealName
      }).done(function (data) {
        resolve(data.hasConverted);
      }).fail(function () {
        resolve(false);
      });
    });
  }

  function isRegisteredCustomer(email) {
    var url = window.bt.settings.leadsApi + 'customer/ftb?email=' + encodeURIComponent(email); // eslint-disable-next-line no-unused-vars

    return new Promise(function (resolve, reject) {
      $.get(url).done(function (data) {
        resolve(!data);
      }).fail(function () {
        // fail open - allowing all buyers to take the deal
        resolve(false);
      });
    });
  }

  function sendLead(email, params) {
    // eslint-disable-next-line no-unused-vars
    return new Promise(function (resolve, reject) {
      var search = window.location.search.split(/[?&]/);
      var t = search.map(function (x) {
        return x.split('=');
      }).filter(function (x) {
        return x.length > 0 && x[0] !== '' && x[0] !== 'email';
      }).map(function (x) {
        return {
          name: x[0],
          value: decodeURIComponent(x[1])
        };
      });
      var obj = {
        optInName: params.optInName || '',
        email: email,
        contactTags: params.contactTags || [],
        params: t,
        isCPA: _isCPA()
      };
      window.console.log('sending: ' + JSON.stringify(obj));
      $.ajax({
        url: window.bt.settings.leadsApi + 'lead/opt-in',
        crossDomain: false,
        method: 'POST',
        contentType: 'application/json',
        processData: false,
        data: JSON.stringify(obj)
      }).done(function (data) {
        try {
          resolve(data.transactionId);
        } catch (err) {
          resolve(false);
        }
      }).fail(function (xhr) {
        window.console.log('failed with: ' + xhr.responseText);
        resolve(false);
      });
    });
  }

  function submitLander($form) {
    var _optIn$contactTags;

    var contactTags = $form.find('[name=contactTags]').val().split(',');

    if ((optIn === null || optIn === void 0 ? void 0 : (_optIn$contactTags = optIn.contactTags) === null || _optIn$contactTags === void 0 ? void 0 : _optIn$contactTags.length) > 0) {
      console.log('[fps] Using contact tags from opt-in settings', {
        contactTags: optIn.contactTags
      });
      contactTags = _toConsumableArray(optIn.contactTags);
    }

    var optInName = $form.find('[name=optInName]').val();

    if (optIn !== null && optIn !== void 0 && optIn.optInName) {
      console.log('[fps] Using opt-in name from opt-in settings', {
        optInName: optIn.optInName
      });
      optInName = optIn.optInName;
    }

    var dealName = $form.find('[name=dealName]').val();

    if (optIn !== null && optIn !== void 0 && optIn.dealName) {
      console.log('[fps] Using deal name from opt-in settings', {
        dealName: optIn.dealName
      });
      dealName = optIn.dealName;
    }

    var formType = $form.data('type');

    if (optIn !== null && optIn !== void 0 && optIn.restrictionLogic) {
      formType = optIn === null || optIn === void 0 ? void 0 : optIn.restrictionLogic;
      console.log('[fps] Using restriction logic from opt-in settings', {
        formType: formType
      });
    }

    var $variant = $form.find('[name=variant]');
    var variant = $variant.val();

    if ($variant.length > 0 && variant === '') {
      window.alert('Please choose your flavor.');
      $variant.focus();
      return false;
    }

    window.bt.optin.disable($('input'), $('select'));
    var $email = $form.find('[name=email]');
    var email = $email.val();
    email = email.replace(/\s+/g, '');
    $email.val(email);
    showLoadingOverlay();
    validateEmail(email, function (result) {
      if (result) {
        var sendLeadPromise = sendLead(email, {
          optInName: optInName,
          contactTags: contactTags
        }); // default logic prevents customer from accepting this offer multiple times

        var registrationFunction = isRegisteredLead;

        if (formType === 'deal') {
          registrationFunction = isRegisteredLead;
        } else if (formType === 'ftb') {
          // allow only first-time buyers to take the deal
          registrationFunction = isRegisteredCustomer;
        } else if (formType === 'none') {
          // bypass all restriction logic
          registrationFunction = function registrationFunction() {
            return Promise.resolve(false);
          };
        }

        var registeredLeadPromise = registrationFunction(email, dealName).then(function (isRegistered) {
          if (!isRegistered) {
            return false;
          }

          _getTrackersLayer().push({
            action: function action(trackers) {
              return trackers.action('lead', 'opt-in', 'Opt-in Sales Page', {
                label: optInName,
                name: 'Duplicate Email Error'
              });
            }
          });

          hideLoadingOverlay();
          $('#usedError').modal({
            backdrop: 'static',
            keyboard: false
          });
          return true;
        });
        return Promise.all([sendLeadPromise, registeredLeadPromise]).then(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              optInResult = _ref2[0],
              isRegistered = _ref2[1];

          if (isRegistered) {
            return false;
          }

          _getTrackersLayer().push({
            action: function action(trackers) {
              return trackers.action('lead', 'opt-in', 'Opt-in Sales Page', {
                name: 'Opt-in',
                label: optInName,
                currency: 'USD',
                value: '0',
                // eslint-disable-next-line camelcase
                success: true,
                email: email
              });
            }
          });

          var ck = Cookies.getJSON('choffer') || {};
          ck.pending = dealName;
          Cookies.set('choffer', ck, {
            expires: new Date(new Date().getTime() + 10 * 60 * 1000)
          });
          /* expire in 10 mins */

          Cookies.set('hasoffer', {
            offerId: pageUrl.query.utm_offer,
            transactionId: optInResult,
            email: email
          }, {
            expires: 1
          });
          Cookies.set('_bt_eml', email, {
            domain: 'biotrust.com'
          });
          /* facilitates auto-fill on BT Checkout */

          var sku = '';

          if ($variant.length > 0) {
            var option = $("option[value='".concat($variant.val(), "']"), $variant);
            sku = option.data('sku');
            console.debug('[fps] Obtained SKU from flavor selection', {
              select: $variant,
              value: variant,
              option: option,
              sku: sku
            });
          } else {
            sku = $form.find('input[name=sku]').val();
            console.debug('[fps] Obtained SKU from form field', {
              sku: sku
            });
          }

          var _window = window,
              _window$bt = _window.bt;
          _window$bt = _window$bt === void 0 ? {} : _window$bt;
          var _window$bt$lil2 = _window$bt.lil;
          _window$bt$lil2 = _window$bt$lil2 === void 0 ? {} : _window$bt$lil2;
          var _window$bt$lil2$enabl = _window$bt$lil2.enabledCheckout,
              enabledCheckout = _window$bt$lil2$enabl === void 0 ? CheckoutProvider.BT_CHECKOUT : _window$bt$lil2$enabl;

          if (enabledCheckout === CheckoutProvider.BT_CHECKOUT) {
            _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
              var addToCartResult;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return createBTCheckoutCart(_defineProperty({}, sku, 1));

                    case 3:
                      addToCartResult = _context.sent;

                      if (!addToCartResult.success) {
                        _context.next = 10;
                        break;
                      }

                      trackAddToCartEvent(new BTCheckoutCartAdapter(addToCartResult.addedCartItems, addToCartResult.cart));
                      redirectToBTCheckout();
                      return _context.abrupt("return");

                    case 10:
                      alert('Something went wrong.  Please try again.');

                    case 11:
                      _context.next = 16;
                      break;

                    case 13:
                      _context.prev = 13;
                      _context.t0 = _context["catch"](0);
                      console.error('Error adding to BT Checkout cart!', _context.t0);

                    case 16:
                      hideLoadingOverlay();

                    case 17:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 13]]);
            }))();
          } else {
            var _variant$split, _offerCYP$product, _offerCYP$product$var;

            // take the first CYP offer from the filtered list
            var _getOfferCYPs$filter = getOfferCYPs().filter(window.bt.optin.offerFilter),
                _getOfferCYPs$filter2 = _slicedToArray(_getOfferCYPs$filter, 1),
                offerCYP = _getOfferCYPs$filter2[0];

            if (!offerCYP) {
              console.error('No offer CYP found');
              window.alert('Offer code not found');
              hideLoadingOverlay();
              return true;
            }

            var variantId = Number((variant === null || variant === void 0 ? void 0 : (_variant$split = variant.split(/\W+/)) === null || _variant$split === void 0 ? void 0 : _variant$split.pop()) || '');
            var selectedVariant = (_offerCYP$product = offerCYP.product) === null || _offerCYP$product === void 0 ? void 0 : (_offerCYP$product$var = _offerCYP$product.variants) === null || _offerCYP$product$var === void 0 ? void 0 : _offerCYP$product$var.find(function (vt) {
              return vt.id === variantId || vt.sku === "".concat(sku);
            });

            if (!selectedVariant) {
              console.error('[fps] The selected variant was not found in the offer CYP', {
                variantId: variantId,
                sku: sku,
                offerCYP: offerCYP
              });
              window.alert('The selected variant was not found');
              hideLoadingOverlay();
              return true;
            } // eslint-disable-next-line no-return-await


            _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return sendToShopifyCheckout(offerCYP, selectedVariant.id, dealName, email);

                    case 2:
                      return _context2.abrupt("return", _context2.sent);

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }))();
          }

          return true;
        });
      } else {
        hideLoadingOverlay();

        _getTrackersLayer().push({
          action: function action(trackers) {
            return trackers.action('lead', 'opt-in', 'Opt-in Sales Page', {
              name: 'Opt-in Email Error',
              label: optInName
            });
          }
        });

        window.bt.optin.enable($('input'), $('select'));
        window.alert('The email address you entered is not valid. Please enter a valid email address.');
        $email.focus().val('');
        return Promise.resolve(false);
      }
    });
    return false;
  }

  var optin = {
    disable: function disable() {
      for (var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++) {
        elements[_key] = arguments[_key];
      }

      elements.forEach(function (x) {
        return x.css('opacity', 0.75).attr('disabled', '');
      });
    },
    enable: function enable() {
      for (var _len2 = arguments.length, elements = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        elements[_key2] = arguments[_key2];
      }

      elements.forEach(function (x) {
        return x.css('opacity', '').attr('disabled', null);
      });
    },
    offerFilter: function offerFilter(value, index) {
      return index === 0;
    }
  };
  /* ****************************************************** */

  /* ******************* PUBLIC API *********************** */

  /* ****************************************************** */

  window.bt = window.bt || {};
  Object.assign(window.bt, {
    validateEmail: validateEmail,
    isRegisteredLead: isRegisteredLead,
    sendLead: sendLead,
    submitLander: submitLander,
    optin: optin
  });
  /* ****************************************************** */

  /* ****************************************************** */

  /* ****************************************************** */

  $(function () {
    $('#email').on('change', function (evt) {
      var $emailInput = $(evt.currentTarget);
      var email = $emailInput.val().replace(/\s+/g, '');
      $emailInput.val(email);
      var data = {
        name: 'Opt-In Form Fill',
        label: $('#optInName').val(),
        success: true,
        email: email
      };

      _getTrackersLayer().push(function (trackers) {
        return trackers.action('lead-form-fill', 'form-fill', data.name, data);
      });
    });
    $('#email').closest('form').submit(function (evt) {
      var $email = $(this).find('#email');
      var $submit = $(this).find('#submit');
      var $form = $(this);
      var urlparams = pageUrl.query;
      var offer = urlparams.utm_offer;
      var email = $email.val().replace(/\s+/g, '');
      var optInName = $form.find('#optInName').val();
      var redirect = new Url($form.attr('action'), true);

      function disable() {
        optin.disable($email, $submit);
      }

      function enable() {
        optin.enable($email, $submit);
      }

      disable();

      if (offer) {
        redirect.query.offer = offer;
      }

      validateEmail(email, function (success) {
        if (success) {
          _getTrackersLayer().push({
            action: function action(trackers) {
              return trackers.action('lead', 'opt-in', 'Opt-in', {
                name: 'Opt-in',
                label: optInName,
                success: true,
                email: email
              });
            }
          });

          return sendLead(email, {
            optInName: optInName,
            contactTags: ($form.find('#contactTags').val() || '').split(',')
          }).then(function () {
            getPageUtms().forEach(function (utm) {
              redirect.query[utm.key] = utm.value;
            });
            window.location.href = redirect.toString();
            return true;
          });
        } else {
          enable();

          _getTrackersLayer().push({
            action: function action(trackers) {
              return trackers.action('lead', 'opt-in', 'Opt-in', {
                label: optInName,
                name: 'Opt-in Email Error'
              });
            }
          });

          window.alert('The email address you entered is not valid. Please enter a valid email address.');
          $email.val('').focus();
          return Promise.resolve(false);
        }
      });
      evt.preventDefault();
      evt.stopImmediatePropagation();
    });
  });
  $(function () {
    function dce(msg) {
      function hexToBase64(str) {
        return window.btoa(String.fromCharCode.apply(null, str.replace(/\r|\n/g, '').replace(/([\da-fA-F]{2}) ?/g, '0x$1 ').replace(/ +$/, '').split(' ')));
      }

      var salt = CryptoJS.enc.Hex.parse(msg.substr(0, 64));
      var iv = CryptoJS.enc.Hex.parse(msg.substr(64, 32));
      var encrypted = hexToBase64(msg.substring(96));
      var key = CryptoJS.PBKDF2('EaHeydWlBFzwbkbb', salt, {
        keySize: 8,
        iterations: 1000
      });
      return CryptoJS.AES.decrypt(encrypted, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
      }).toString(CryptoJS.enc.Utf8);
    }

    var urlparams = pageUrl.query;

    if (urlparams.gid) {
      var email = dce(urlparams.gid);

      if (email) {
        $('[name=email]').val(email.replace(/\s+/g, ''));
      }
    }
  });
})();